import { StarIcon } from "@heroicons/react/solid";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import Avatar from "shared/Avatar/Avatar";
import { IReviews } from "types/interfaces";
import moment from "moment";

export interface CommentListingProps {
  className?: string;
  data?: IReviews;
  hasListingTitle?: boolean;
}

const CommentListing: FC<CommentListingProps> = ({
  className = "",
  data,
  hasListingTitle,
}) => {
  const totalStar = Array.apply(null, Array(data?.stars || 0));
  return (
    <div
      className={`nc-CommentListing flex space-x-4 ${className}`}
      data-nc-id="CommentListing"
    >
      <div className="pt-0.5">
        <Avatar
          sizeClass="h-10 w-10 text-lg"
          radius="rounded-full"
          userName={data?.author.displayName}
          imgUrl={data?.author.avatar}
        />
      </div>
      <div className="flex-grow">
        <div className="flex justify-between space-x-3">
          <div className="flex flex-col">
            <div className="text-sm font-semibold">
              <span>{data?.author.displayName}</span>
              {hasListingTitle && (
                <>
                  <span className="text-neutral-500 dark:text-neutral-400 font-normal">
                    {` review in `}
                  </span>
                  <Link to="/">The Lounge & Bar</Link>
                </>
              )}
            </div>
            <span className="text-sm text-neutral-500 dark:text-neutral-400 mt-0.5">
              {moment(data?.createdAt).format("ll")}
            </span>
          </div>
          <div className="flex text-yellow-500">
            {totalStar.map((_, index) => {
              return <StarIcon className="w-4 h-4" key={index} />;
            })}
          </div>
        </div>
        <span className="block mt-3 text-neutral-6000 dark:text-neutral-300">
          {data?.message}
        </span>
      </div>
    </div>
  );
};

export default CommentListing;
